<template>
  <div class="flex flex-col w-full ">
    <Timeline
      :value="events"
      class="w-full"
      :pt="{
      eventcontent: {
        style: 'text-align: right; padding-right: 0.5rem !important; align-items: center; margin-top: -3px;',
      }
    }">
      <template #content="slotProps">
        <div v-if="loyaltyProgramPromoType === 'points'" class="flex flex-col gap-1">
          <span>{{ DateTime.fromISO(slotProps.item.date).toLocaleString(DateTime.DATE_MED) }}</span>
          <span class="text-sm">
            {{ slotProps.item.type === 'deposit' ? 'צבירה של ' : 'שימוש ב' }}{{
              parseFloat(slotProps.item.amount.toFixed(2))
            }} נקודות
          </span>
        </div>
        <div v-else-if="loyaltyProgramPromoType === 'discount'" class="flex flex-col gap-1">
          <span>{{ DateTime.fromISO(slotProps.item.date).toLocaleString(DateTime.DATE_MED) }}</span>
          <span v-if="slotProps.item.type === 'deposit'" class="text-sm">
            צבירה עבור ביקור
          </span>
          <span v-else class="text-sm">
            מימוש הטבה
          </span>
        </div>

      </template>
    </Timeline>

  </div>
</template>

<script setup lang="ts">
import {PropType} from "vue";
import {ICustomer, LoyaltyProgramPromosTypes} from "@torim-app/types";
import {DateTime} from "luxon";

const props = defineProps({
  clientData: {
    type: Object as PropType<ICustomer>,
    required: true
  },
  loyaltyProgramPromoType: {
    type: String as PropType<LoyaltyProgramPromosTypes>,
    required: true
  }
})

const events = props.clientData.loyalty ? [
  ...(props.clientData.loyalty[props.loyaltyProgramPromoType]?.deposits.map(x => ({
    ...x, type: 'deposit'
  })) ?? []),
  ...(props.clientData.loyalty[props.loyaltyProgramPromoType]?.withdraws.map(x => ({
    ...x, type: 'withdraw'
  })) ?? []),
].sort((a, b) => a.date > b.date ? -1 : 1) : []
</script>

<style scoped lang="scss">

</style>
